import React from 'react'
import { useEffect, useState } from "react";
import { Link } from 'react-router-dom'
import PageSection from "../components/PageSection";
import { Hero } from '../components/Hero'

const Home = () => {
  return (
    <div className="">
        <Hero />
    </div>
  )
}

export default Home